import { useSharedState } from '@trello/shared-state';

import { workspaceState } from './workspaceState';

export function useWorkspace() {
  return useSharedState(workspaceState);
}
